if (!customElements.get('feature-accordion-media')) {
  customElements.define(
    'feature-accordion-media',
    class FeatureAccordionMedia extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-feature-accordion-item]'));
        this.panels = Array.from(this.querySelectorAll('[data-feature-media-panel]'));
        this.autoplayVideos = this.dataset.videoAutoplay === 'true';
        this.loopVideos = this.dataset.videoLoop === 'true';
        this.abortController = new AbortController();

        this.items.forEach((item) => {
          item.addEventListener(
            'toggle',
            () => {
              if (!item.open) return;
              this.activateItem(item);
            },
            { signal: this.abortController.signal }
          );
        });

        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const item = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
            if (!item) return;
            item.open = true;
            this.activateItem(item);
            item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          },
          { signal: this.abortController.signal }
        );

        const openItem = this.items.find((item) => item.open) || this.items[0];
        if (openItem) this.activateItem(openItem, false);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      activateItem(activeItem, closeOthers = true) {
        if (closeOthers) {
          this.items.forEach((item) => {
            if (item !== activeItem && item.open) item.open = false;
          });
        }

        const requestedTarget = activeItem.dataset.mediaTarget || 'default';
        const requestedPanel = this.panels.find((panel) => panel.dataset.featureMediaPanel === requestedTarget);
        this.activatePanel(requestedPanel ? requestedTarget : 'default');
      }

      activatePanel(target) {
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.featureMediaPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', String(!isActive));

          panel.querySelectorAll('video').forEach((video) => {
            video.autoplay = this.autoplayVideos;
            video.loop = this.loopVideos;

            if (!isActive) {
              video.pause();
              return;
            }

            if (this.autoplayVideos) {
              video.muted = true;
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }
    }
  );
}
